import UserGrowthChart from "./components/UserGrowthChart";
import OrganizationGrowthChart from "./components/OrganizationGrowthChart";
import StatsCards from "./components/StatsCards";
import ActiveUsersChart from "./components/ActiveUsersChart";
import AccountDistributionChart from "./components/AccountDistributionChart";

function AdminDashboard() {
  return (
    <div className="bg-white h-full flex flex-col overflow-hidden">
      <div className="w-full mx-auto pt-6 sm:pt-10 px-4 sm:px-6 lg:px-10 flex-shrink-0">
        <div className="mb-6">
          <h3 className="text-xl font-semibold tracking-tight text-gray-900">Dashboard</h3>
          <p className="text-sm text-gray-500 mt-0.5">View platform statistics and growth</p>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto px-4 sm:px-6 lg:px-10 pb-10">
        <div className="grid gap-5">
          <StatsCards />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <ActiveUsersChart />
            <UserGrowthChart />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
            <AccountDistributionChart />
            <OrganizationGrowthChart />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
